"use client";

import type { Extra } from "@/lib/types";

interface ExtrasPickerProps {
  extras: Extra[];
  value: number[];
  onChange: (ids: number[]) => void;
}

export default function ExtrasPicker({ extras, value, onChange }: ExtrasPickerProps) {
  if (extras.length === 0) return null;

  function toggle(id: number) {
    if (value.includes(id)) {
      onChange(value.filter((x) => x !== id));
    } else {
      onChange([...value, id]);
    }
  }

  return (
    <fieldset>
      <legend className="block text-sm font-medium text-gray-700 mb-2">Papildomos paslaugos</legend>
      <div className="space-y-2">
        {extras.map((extra) => (
          <label key={extra.id} className="flex items-center gap-2 text-sm text-gray-700 cursor-pointer">
            <input
              type="checkbox"
              checked={value.includes(extra.id)}
              onChange={() => toggle(extra.id)}
              className="h-4 w-4 rounded border-gray-300 text-blue-600 focus:ring-blue-500"
            />
            <span>
              {extra.name} (+{extra.price} €)
            </span>
          </label>
        ))}
      </div>
    </fieldset>
  );
}
